import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InquiryComponent } from './page/inquiry/inquiry.component';
import { MobileTicketComponent } from './mobile/mobile-ticket/mobile-ticket.component';
import { MobileInquiryComponent } from './mobile/mobile-inquiry/mobile-inquiry.component';
import { MobileLogComponent } from './mobile/mobile-log/mobile-log.component';
import { AuthTestComponent } from './components/auth-test/auth-test.component';
const appRoutes: Routes = [
  // {path: '', redirectTo: '/', pathMatch: 'full'},  //TODO: Setup default startup page
  // Temporarily disable auto-redirect to avoid Azure AD redirect URI mismatch
  // { path: '', redirectTo: '/inquiry', pathMatch: 'full' },
  { path: '', component: InquiryComponent },
  { path: 'inquiry', component: InquiryComponent },
  { path: 'inquiry/:categoryCode', component: InquiryComponent },
  { path: 'inquiry/:categoryCode/:subCategoryCode', component: InquiryComponent },
  { path: 'auth-test', component: AuthTestComponent }, // Development auth testing component
  { path: 'category', loadChildren: () => import('./page/category/category.module').then(m => m.CategoryModule) },
  { path: 'subcategory', loadChildren: () => import('./page/subcategory/subcategory.module').then(m => m.SubcategoryModule) },
  { path: 'support', loadChildren: () => import('./page/support-team/support-team.module').then(m => m.SupportTeamModule) },
  { path: 'ticket', loadChildren: () => import('./page/external-ticket/external-ticket.module').then(m => m.ExternalTicketModule) },
  { path: 'vdi-request', loadChildren: () => import('./page/vdi-request/vdi-request.module').then(m => m.VdiRequestModule) },
  { path: '**', redirectTo: '/inquiry' }
];
function IsMobile() {
  let userAgent = navigator.userAgent,Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];
  return Agents.some((i)=>{
      return userAgent.includes(i)
  })
}
const mobileRoutes:Routes = [
  // Temporarily disable auto-redirect to avoid Azure AD redirect URI mismatch
  // { path: '', redirectTo: '/inquiry', pathMatch: 'full' },
  { path: '', component: MobileInquiryComponent },
  { path: 'inquiry', component: MobileInquiryComponent },
  { path: 'inquiry/:categoryCode', component: MobileTicketComponent },
  { path: 'inquiry/:categoryCode/:subCategoryCode', component: MobileTicketComponent },
  { path: 'mobile-ticket/:categoryCode', component: MobileTicketComponent },
  { path: 'mobile-ticket/:categoryCode/:subCategoryCode', component: MobileTicketComponent },
  { path: 'mobile-ticket', component: MobileTicketComponent },
  { path: 'mobile-log', component: MobileLogComponent },
  { path: 'auth-test', component: AuthTestComponent }, // Development auth testing component
  { path: 'category', loadChildren: () => import('./mobile/category/category.module').then(m => m.CategoryModule) },
  { path: 'subcategory', loadChildren: () => import('./mobile/subcategory/subcategory.module').then(m => m.SubcategoryModule) },
  { path: 'support', loadChildren: () => import('./mobile/support-team/support-team.module').then(m => m.SupportTeamModule) },
  { path: 'ticket', loadChildren: () => import('./mobile/external-ticket/external-ticket.module').then(m => m.ExternalTicketModule) },
  { path: 'vdi-request', loadChildren: () => import('./page/vdi-request/vdi-request.module').then(m => m.VdiRequestModule) },
  { path: '**', redirectTo: '/inquiry' }
]


@NgModule({
  imports: [
    RouterModule.forRoot(IsMobile() ? mobileRoutes : appRoutes, {
      //RouterModule.forRoot( appRoutes, {
      // enableTracing: !environment.production, // tracing is not enabled at production environment

      useHash: true,

      onSameUrlNavigation: 'reload',

      // Important! Let components in child routes able to access param data resolved from parent routes
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
